import './SelectedCharacterPanel.css';

import React, { FC } from 'react';

import { useAppSelector } from 'js/store/hooks';

import { CHARACTERS } from '../CharactersView/CharacterConsts';
import useGetSearchResult from '../SearchResultView/hooks/useGetSearchResult';

const SelectedCharacterPanel: FC = () => {
  const selectedCharacterName = useAppSelector(state => state.imageSearch.selectedCharacterName);
  const searchType = useAppSelector(state => state.imageSearch.searchType);
  const submittedSearchInput = useAppSelector(state => state.imageSearch.submittedSearchInput);
  const selectedCategoryId = useAppSelector(state => state.imageSearch.selectedCategoryId);

  const { getTabResultCount } = useGetSearchResult(searchType, submittedSearchInput, selectedCategoryId);
  const poseCount = getTabResultCount('videoscribe');

  const character = CHARACTERS.find(c => c.name === selectedCharacterName);

  if (!character) return null;

  const { SvgComponent, name } = character;

  return (
    <div className="SelectedCharacterPanel">
      <div className="SelectedCharacterPanel__avatar">
        <SvgComponent className="SelectedCharacterPanel__avatarSvg" />
      </div>
      <div className="SelectedCharacterPanel__text">
        <span className="SelectedCharacterPanel__name">{name}</span>
        {poseCount !== undefined && (
          <span className="SelectedCharacterPanel__details">{poseCount} poses available</span>
        )}
      </div>
    </div>
  );
};

export default SelectedCharacterPanel;
